import { render, staticRenderFns } from "./card-step-instructions-02.vue?vue&type=template&id=83e59952&scoped=true&"
import script from "./card-step-instructions-02.vue?vue&type=script&lang=js&"
export * from "./card-step-instructions-02.vue?vue&type=script&lang=js&"
import style0 from "./card-step-instructions-02.vue?vue&type=style&index=0&id=83e59952&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e59952",
  null
  
)

export default component.exports